import InfoSlider from "./InfoSlider";

export default InfoSlider;
